import React, { FC } from 'react';
import { css } from '@emotion/css';
import Link, { LinkProps } from 'evcharging/components/Link';
import { Theme } from 'evcharging/app/themes';
import useTheme from 'evcharging/hooks/useTheme';

interface LinkSecondaryButton extends LinkProps {
  mobilePx?: number;
}

const LinkSecondaryButton: FC<LinkSecondaryButton> = (props) => {
  const theme = useTheme();
  const styles = createStyles(theme, props);
  return <Link className={styles.root} {...props} />;
};

const createStyles = (theme: Theme, { mobilePx = 30 }: LinkSecondaryButton) => ({
  root: css`
    display: inline-flex;
    justify-content: center;
    align-items: center;
    border: 1px ${theme.colors.accent} solid;
    border-radius: 6px;
    height: 50px;
    padding: 0 16px;
    vertical-align: middle;
    text-decoration: none;
    cursor: pointer;
    user-select: none;
    font-weight: bold;
    color: ${theme.colors.accent};
    transition: all 0.15s ease-in-out;
    ${theme.breakpoints.mobile.down} {
      height: 45px;
      padding: 0 ${mobilePx}px;
    }
  `,
});

export default LinkSecondaryButton;
